import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get("lang");

const messages = {};
const languageFiles = require.context('@/_helpers/lang', false, /\.js$/);
const langList = languageFiles.keys().map((key) => {
  const language = key.replace('./', '').replace('.js', '');
  messages[language] = languageFiles(key).default || languageFiles(key);
  return language;
});

const getLanguage = () => {
  if (myParam && langList.includes(myParam)) {
    return myParam;
  }

  const storedLanguage = localStorage.getItem("systemLanguage");
  if (storedLanguage && langList.includes(storedLanguage)) {
    return storedLanguage;
  }

  const browserLanguage = navigator.languages[0].split('-')[0];
  return langList.includes(browserLanguage) ? browserLanguage : "en";
};

const selectedLanguage = getLanguage();
localStorage.setItem("systemLanguage", selectedLanguage);

export default new VueI18n({
  locale: selectedLanguage,
  messages,
});